import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { GetRoleForManagementPageQuery } from "@me-team/host/main/RoleManagement/graphql/roleManagement.hooks";
import { ApolloQueryResult } from "@apollo/client";

type RoleToDel = {
    roleId: number;
    roleName: string;
    isUsableRole?: boolean;
};

type RoleToClone = {
    roleId: number;
    roleName: string;
};

type RoleManagementContextValue = {
    onDeleteRole: (roleInfo: RoleToDel) => void;
    deleteTarget: RoleToDel | null;
    setDeleteTarget: Dispatch<SetStateAction<RoleToDel | null>>;
    onCloneRole: (roleInfo: RoleToClone) => void;
    roleData: GetRoleForManagementPageQuery;
    roleDataLoading: boolean;
    refetchRole: () => Promise<ApolloQueryResult<any>>;
    currentPage: number;
    pageCount: number;
    totalItems: number;
    firstItemIndex: number;
    lastItemIndex: number;
    handlePageChange: (pageNumber: number) => void;
};

const RoleManagementContext = createContext<RoleManagementContextValue | null>(null);

export const useRoleManagementContext = (): RoleManagementContextValue => {
    const context = useContext(RoleManagementContext);

    if (!context) {
        throw new Error("useRoleManagementContext must be used inside RoleManagementProvider");
    }

    return context;
};

export default RoleManagementContext;
